import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import Knowmorebtn from "../button/Knowmorebtn";
import BackgroundImage from "../../assets/images/AbstractImg.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import emailjs from "@emailjs/browser";
import { toast } from "react-hot-toast";

const TalktoUs = ({ Header }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted");
    console.log("Form Data:", formData);

    // Validate that required fields are not empty
    if (
      !formData.fullName.trim() ||
      !formData.email.trim() ||
      !formData.message.trim()
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // Validate email format using a regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    // Validate that the terms are agreed to
    if (!formData.agree) {
      toast.error("Please agree to the terms and conditions.");
      return;
    }

    const templateParams = {
      fname: formData.fullName,
      email: formData.email,
      message: formData.message,
    };

    console.log("Sending email with params:", templateParams);

    try {
      const response = await emailjs.send(
        "service_lspmqxc",
        "template_yu9qgg8",
        templateParams,
        "ps-p6gBHKx9uv4TtB"
      );
      console.log("Email sent successfully!", response.status, response.text);
      toast.success("Your message has been sent successfully!");

      // Reset the form fields after successful submission
      setFormData({
        fullName: "",
        email: "",
        message: "",
        agree: false,
      });
    } catch (error) {
      console.error("Failed to send email. Error:", error);
      toast.error("Failed to send your message. Please try again later.");
    }
  };

  return (
    <Box
      sx={{
        position: "relative", // To allow background image to be positioned properly
        padding: { xs: "4rem 0rem", sm: "4rem 3rem", md: "4rem 10rem" },
        backgroundColor: "#ecebeb",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      >
        <LazyLoadImage
          src={BackgroundImage}
          effect="blur"
          width="100%"
          height="100%"
          style={{
            objectFit: "cover",
            opacity: 0.7,
          }}
        />
      </Box>

      {/* Form Container */}
      <Box
        sx={{
          maxWidth: { xs: "90%", sm: "100%", md: "80%", xl: "1440px" },
          margin: "0 auto",
          height: "auto",
          zIndex: 1,
          borderRadius: "1.2rem",
          backgroundColor: "rgba(241, 241, 241, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "1.2rem 2rem",
          position: "relative",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.6rem",
            fontWeight: "500",
            marginTop: "1.2rem",
            textAlign: "center",
            color: "#FF6A00",
          }}
        >
          {Header || (
            <>
              Talk to <span style={{ color: "rgba(255, 102, 0, 1)" }}>Us</span>
            </>
          )}
        </Typography>

        {/* Form Fields */}
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1.2rem",
            marginTop: "2rem",
          }}
          noValidate
          autoComplete="off"
        >
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <TextField
              placeholder="Full Name"
              name="fullName"
              variant="outlined"
              fullWidth
              value={formData.fullName}
              onChange={handleChange}
              InputProps={{
                style: { color: "black" },
              }}
              sx={{
                backgroundColor: "white",
                borderRadius: "12px",
                "& input::placeholder": {
                  fontFamily: "Barlow",
                  color: "black",
                  fontSize: "1.2rem",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0.4rem",
                  "& fieldset": {
                    border: "none",
                    fontSize: "1.2rem",
                  },
                },
              }}
            />
            <TextField
              placeholder="Email"
              name="email"
              variant="outlined"
              fullWidth
              value={formData.email}
              onChange={handleChange}
              InputProps={{
                style: { color: "black" },
              }}
              sx={{
                backgroundColor: "white",
                borderRadius: "12px",
                "& input::placeholder": {
                  fontFamily: "Barlow",
                  color: "black",
                  fontSize: "1.2rem",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0.4rem",
                  "& fieldset": {
                    border: "none",
                    fontSize: "1.2rem",
                  },
                },
              }}
            />
          </Box>
          <TextField
            placeholder="Message"
            name="message"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            value={formData.message}
            onChange={handleChange}
            InputProps={{
              style: { color: "black" },
              fontSize: "1.2rem",
            }}
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              "& textarea::placeholder": {
                fontFamily: "Barlow",
                color: "black",
                fontSize: "1.2rem",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "0.4rem",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={formData.agree}
                onChange={handleChange}
                name="agree"
                color="primary"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: "1.2rem",
                    border: "1px",
                  },
                }}
              />
            }
            label="I agree that my submitted data is being collected and stored."
            sx={{
              "& .MuiFormControlLabel-label": {
                fontFamily: "Barlow",
              },
            }}
          />

          {/* Centering the buttons */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
            <Button
              onClick={handleSubmit}
              sx={{
                backgroundColor: "rgba(243, 107, 43, 1)",
                color: "rgba(255, 255, 255, 1)",
                textDecoration: "none",
                fontFamily: "Plus Jakarta Sans",
                fontWeight: "300",
                textTransform: "capitalize",
                padding: "8px 16px",
              }}
            >
              Send Message
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TalktoUs;
